import { AgilityRiskService } from '../../providers/agility-risk.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RiskFormula } from '../../models/risk-formula';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { FormulaDescriptionComponent } from './formula-description/formula-description.component';
import { RiskBandSliderComponent } from './risk-band-slider/risk-band-slider.component';
import { RiskFormulaType } from '../../models/risk-formula-type';
import { AgilityRiskSpinnerService } from '../../providers/agility-risk-spinner.service';
import { AgilityRiskMessageService } from '../../providers/agility-risk-message.service';
import { RiskFormulaListComponent } from './risk-formula-list/risk-formula-list.component';

@Component({
  selector: 'lib-risk-formula-management',
  templateUrl: './risk-formula-management.component.html',
  styleUrls: ['./risk-formula-management.component.scss']
})
export class RiskFormulaManagementComponent implements OnInit {
  @ViewChild(FormulaDescriptionComponent) formulaDescriptionRef!: FormulaDescriptionComponent;
  @ViewChild(RiskBandSliderComponent) slider!: RiskBandSliderComponent;
  @ViewChild(RiskFormulaListComponent) formulaListRef!: RiskFormulaListComponent;
  addEditFormula = false;
  selectedFormula!: RiskFormula;

  constructor(
    private agilityRiskService: AgilityRiskService,
    public translateService: TranslateService,
    public dialogService: DialogService,
    public spinner: AgilityRiskSpinnerService,
    private messageService: AgilityRiskMessageService,
  ) { }

  ngOnInit(): void {
  }

  resetAddEditState(): void {
    this.addEditFormula = false;
    this.formulaDescriptionRef.formulaEditForm?.reset();
  }

  createFormula(): void {
    if (this.addEditFormula) {
      return;
    }

    this.addEditFormula = true;
    this.formulaDescriptionRef.displayForm(null);
  }

  formulaSelected(): void {
    this.addEditFormula = true;
    this.formulaDescriptionRef?.displayForm(this.selectedFormula);
  }

  onCancel(): void {
    this.selectedFormula = null;
    this.resetAddEditState();
  }

  onSave(): void {
    this.slider?.savePositions();

    if (this.formulaDescriptionRef.formulaEditForm.invalid) {
      this.formulaDescriptionRef.markFormAsInvalid();
      return;
    }

    const formValue = this.formulaDescriptionRef.getFormValue();
    const formulaList = this.formulaListRef.formulaList;

    let formula: any;
    if (this.selectedFormula?.id) {
      formula = formulaList.find(formula => {
        return formula.id === this.selectedFormula.id;
      });
    } else {
      formula = new RiskFormula();
    }

    formula.description = formValue.description;
    formula.targetType = formValue.targetType;
    // todo for now only allow multipart
    formula.formulaType = RiskFormulaType.multiPart;
    formula.status = formValue.status;
    formula.name = formValue.name;
    formula.rounding = formValue.rounding;

    if (formula.id) {
      formula.equation = this.selectedFormula.equation;
      formula.formulas = this.selectedFormula.formulas;
    }

    this.spinner.start();
    this.agilityRiskService.saveRiskFormula(formula).subscribe({
      next: () => {
        this.addEditFormula = false;
        this.selectedFormula = null;
        this.messageService.success(this.translateService.instant('common.saved'));
        this.formulaListRef.fetchRiskFormulas();
      },
      error: (error: HttpErrorResponse) => {
        this.messageService.error(this.translateService.instant('common.failedToSave'));
        console.error(error.message);
      }
    }).add(() => this.spinner.stop());

    this.resetAddEditState();
  }
}
